import { useId } from "react";
import type { FC, ReactNode } from "react";
import ContentLoader, { type IContentLoaderProps } from "react-content-loader";

const Placeholder: FC<
  {
    children?: ReactNode;
    className?: string;
    height?: string;
    /**
     * SVG attribute used to preserve aspect ratio in a container given a viewbox
     */
    preserveAspectRatio?: string;
    /**
     * SVG attribute to determine viewbox parameters
     */
    viewBox?: string;
    /**
     * Width for your svg element. Can be fixed or percentage.
     */
    width?: string;
    style?: React.CSSProperties;
    "data-testid"?: string;
  } & IContentLoaderProps
> = ({ children, ...props }) => {
  // Generate a stable, unique ID for this component instance
  const reactId = useId();
  // Sanitize the ID (remove colons) to ensure it works safely as an SVG ID/URL reference
  const safeId = reactId.replace(/:/g, "");

  const combinedProps = {
    backgroundColor: "#f3f3f3",
    foregroundColor: "#ecebeb",
    speed: 2,
    // Set our stable ID as the default uniqueKey.
    // Explicit props will still override this.
    uniqueKey: `skeleton-${safeId}`,
    ...props,
  };

  return <ContentLoader {...combinedProps}>{children}</ContentLoader>;
};

export const Rect = ({ ...props }) => {
  const combinedProps = { rx: "3", ry: "3", x: "0", y: "0", ...props };
  return <rect {...combinedProps} />;
};

export default Placeholder;
